import { useState, useEffect } from "react";
import loader from "../assets/images/loader.gif";
import { Button, Card, Row, Col, Form } from 'react-bootstrap';
import "./Invoice.scss"
import { ArrowsAngleExpand, CheckCircleFill, ChevronRight, CircleFill } from "react-bootstrap-icons";
import TaskListBlade from "./TaskListBlade";
import Loader from "../Loader/Loader";
import WebService from "../utility/WebService";
import Accordion from 'react-bootstrap/Accordion';

interface propData {
  data: any;
  code: string;
  token: string;
}

const TaskList = (props: propData) => {
  const [isLoading, setLoading] = useState(false);
  const [show2, setShow2] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false);
  const [taskData, setTaskData] = useState<any>([])
  const [ShowAllChecklist, setAllChecklist] = useState(true)
  const [selectedTaskData, setSelectedTaskData] = useState<any>({})
  const [selectedTaskIds, setSelectedTaskIds] = useState<any>({})
  const [detailData, setDetailData] = useState<any>()

  useEffect(() => {
    getTaskList()
  }, [props.data])

  const getTaskList = () => {
    setLoading(true)
    WebService.postAPI({
      action: `api/Invoice/tasklistNew`,
      body: {
        companyCode: props.code,
        invoiceNumber: props.data?.callInfo?.invoiceNum,
        isExternal: true
      }
    })
      .then((res: any) => {
        setTaskData(res.data)
        getTaskListDetail(res.data[0].id, res.data[0].tasklistResId)
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
      })
  }


  const handleShow2 = (e: any, data: any) => {
    setSelectedTaskIds(data);
    setSelectedTaskData(e);
    setShow2(true);
  };


  const onCloseTaskListBlade = (value: any, type: any) => {
    setShow2(value)
  }

  const getTaskListDetail = (id: string, tasklistResId?: string) => {
    setDetailData(null)
    setLoading(true)
    WebService.postAPI({
      action: `api/Invoice/tasklist/details_v2new/${id}`,
      body: {
        companyCode: props.code,
        invoiceNumber: props.data?.callInfo?.invoiceNum,
        techResponseListId: tasklistResId
      }
    })
      .then((res: any) => {
        for (var j in res.data.values) {
          for (var k in res.data.values[j].list) {
            if (res.data.values[j].list[k].selectedValue != null) {
              if (res.data.values[j].list[k].selectedValue.value != null && res.data.values[j].list[k].selectedValue.value != "") {
                // We added this condition because we are getting selected value in name
                if (res.data.values[j].list[k].type == 'DROPDOWN' || res.data.values[j].list[k].type == 'CHECKBOX') {
                  res.data.values[j].list[k].selectedValue.selectedValue = res.data.values[j].list[k].selectedValue.name
                } else {
                  // We added this condition because we are getting selected value in value
                  res.data.values[j].list[k].selectedValue.selectedValue = res.data.values[j].list[k].selectedValue.value
                }
              }
            }
          }
        }
        setDetailData(res.data)
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
      })
  }

  console.log("detailData.values.length", detailData)

  return <>
    <TaskListBlade
      isShow={show2}
      isClose={onCloseTaskListBlade}
      Ids={selectedTaskData}
      data={selectedTaskIds}
    />
    <Loader show={isLoading} />
    <div className=''>
      <Row>

        <Col md={12} id="wideCol">
          <Row>
            <Col md={12} id="wideCol">
              <Card className="border-0 p-3 task-list-card card-style" style={{ marginBottom: 50 }}>
                {
                  ShowLoader == true ? (
                    <div style={{ textAlign: "center" }}>
                      <img
                        style={{ position: "relative" }}
                        src={loader}
                        alt="No loader found"
                      />
                      <div style={{ position: "relative", color: "white" }}>
                        Loading...
                      </div>

                    </div>
                  ) : (
                    <div>
                      <div className="col-12 d-flex justify-content-end mb-2">
                        <div className="font-14 load-more" onClick={() => window.open(window.location.origin + `/tasklist?token=${props.token}`, "_blank")}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrows-fullscreen" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707zm0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707zm-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707z" />
                          </svg>
                        </div>
                      </div>
                      {
                        ((detailData && detailData.values.length == 0) || detailData == undefined) &&
                        <div className="error-message">No Tasklist Available</div>
                      }
                      <Accordion className='accordian'>
                        {
                          taskData.length > 0 && taskData.map((res: any, index: number) => {
                            return (
                              <>
                                <Accordion.Item  key={res.id}  eventKey={res.id} className='accordian-item' onClick={() => getTaskListDetail(res.id, res.tasklistResId)}>
                                  <Accordion.Header>
                                    {res.headerName}  ({res.createdOn ? new Date(res.createdOn).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }) : ''})
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    <div className="d-flex row col-12">
                                      {
                                        detailData && detailData.values.length > 0 && detailData.values.map((res: any) => {
                                          return (
                                            <>
                                              {
                                                res.list && res.list.map((val: any) => {
                                                  var value = ''
                                                  if (val.typeId == 'CAPTURE_SIGNATURE') {
                                                    var check = val.selectedValue?.selectedValue?.includes('data:image/png;base64,')
                                                    if (check) {
                                                      console.log("Here")
                                                      value = val.selectedValue?.selectedValue.replace('data:image/png;base64,', '')
                                                    } else {
                                                      value = 'data:image/png;base64,' + val.selectedValue?.selectedValue
                                                    }
                                                  }
                                                  return (
                                                    <>
                                                      {
                                                        ((val.selectedValue?.selectedValue != null && val.selectedValue?.selectedValue != '') || (val.selectedValueArray != null && val.selectedValueArray.length > 0)) &&
                                                        <>
                                                          <div className="col-12 p-2">
                                                            <div className="checklist-title text-truncate" title={val.name}>
                                                              {val.name}
                                                            </div>
                                                            <div>
                                                              {val.typeId == 'CAPTURE_SIGNATURE' ? <div>
                                                                <img src={`${value}`} style={{ height: 150, width: 200 }} />
                                                              </div>
                                                                :
                                                                val.typeId == 'SPOTLIGHT_CONTROL' ?
                                                                  <div className="d-flex">
                                                                    <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#c02525", opacity: val?.selectedValue?.selectedValue == 'RED' ? 10 : 0.5 }}>
                                                                      {
                                                                        val?.selectedValue?.selectedValue == 'RED'
                                                                          ?
                                                                          <CheckCircleFill color="white" size={13} />
                                                                          :
                                                                          <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'RED' ? true : false} name="name" />
                                                                      }
                                                                    </Form.Group>
                                                                    <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#c0a925", opacity: val?.selectedValue?.selectedValue == 'YELLOW' ? 10 : 0.5 }}>
                                                                      {
                                                                        val?.selectedValue?.selectedValue == 'YELLOW'
                                                                          ?
                                                                          <CheckCircleFill color="white" size={13} />
                                                                          :
                                                                          <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'YELLOW' ? true : false} name="name" />
                                                                      }
                                                                    </Form.Group>
                                                                    <Form.Group className="grade-level grade-width" style={{ backgroundColor: "#438e23", opacity: val?.selectedValue?.selectedValue == 'GREEN' ? 10 : 0.5 }}>
                                                                      {
                                                                        val?.selectedValue?.selectedValue == 'GREEN'
                                                                          ?
                                                                          <CheckCircleFill color="white" size={13} />
                                                                          :
                                                                          <Form.Check value={val?.selectedValue?.selectedValue} disabled={true} type="radio" checked={val?.selectedValue?.selectedValue == 'GREEN' ? true : false} name="name" />
                                                                      }
                                                                    </Form.Group>
                                                                  </div>
                                                                  :
                                                                  val.selectedValue?.selectedValue}
                                                              {val.typeId == 'UPLOAD_IMAGE' &&
                                                                <div>
                                                                  {
                                                                    val.selectedValueArray && val.selectedValueArray.length > 0 && val.selectedValueArray.map((val: any) => {
                                                                      return (
                                                                        <img src={val?.documentThumbUrl} style={{ height: 50, width: 50 }} />
                                                                      )
                                                                    })
                                                                  }

                                                                </div>
                                                              }
                                                              <div className="d-flex row" style={{ marginLeft: -4 }}>
                                                                {
                                                                  val.selectedValueArray && val.selectedValueArray.length > 0 && val.selectedValueArray.map((response: any, i: any) => {
                                                                    return (
                                                                      <div className="w-auto p-1">{i == val.selectedValueArray.length - 1 ? response.name : response.name + ' ,'}</div>
                                                                    )
                                                                  })
                                                                }
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </>
                                                      }
                                                    </>
                                                  )
                                                })
                                              }
                                            </>
                                          )
                                        })
                                      }
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </>
                            )
                          })
                        }
                      </Accordion>

                    </div>
                  )
                }
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  </>;
};

export default TaskList;


